module.exports = "<div class=\"sun-app-contents\" (swiperight)=\"goReport()\" data-mc-options='{\"touchAction\": \"pan-y\"}'>\r\n  <div class=\"sun-list-single-container\">\r\n    <ul>\r\n      <li *ngFor=\"let store of stores; let i = index;\">\r\n        <a (click)=\"navigateToOldReportList(store)\">\r\n          <p class=\"sun-text\">{{store.storeName}}</p>\r\n          <i class=\"sun-icon-arrow_right_m\"></i>\r\n        </a>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/kvap0301/kvap0301.component.html
// module id = ./src/app/component/kvap0301/kvap0301.component.html
// module chunks = main